import bizNodeModel from '../../bizNodeModel.mjs'

export default bizNodeModel({
    amNo: {
        name: () => '分析域代码',
    },

    amName: {
        name: () => '分析域名称',
        required: () => true,
    },
})
